import queueConstants from "@/constants/queueConstants"
import helpers from "@/helpers/index"
import { queueApiV1NoCache } from "../axiousWithCache"

const state = {
  clearTimeToEdit: null,
  updateClearTimeList: false
}

const getters = {
  userAccess: (_state, _getters, _rootState, rootGetters) => {
    const currentRole = rootGetters["authentication/getUserRole"]
    if (queueConstants.QUEUE_ADMIN_ROLES.includes(currentRole)) {
      return {
        queueModule: true,
        queueSettings: true
      }
    }
    return {
      queueModule: false,
      queueSettings: false
    }
  },
  hasQueueSettingsAccess: (_state, getters) => {
    return getters?.userAccess?.queueSettings || false
  },
  hasQueueModuleAccess: (_state, getters) => {
    return getters?.userAccess?.queueModule || false
  },
  queueModule: (_state, _getters, rootState) => {
    const activeSchoolModules = rootState?.schools?.activeSchoolModules || []
    return (
      activeSchoolModules.find(
        (module) => module?.name === queueConstants.MODULE
      ) || null
    )
  },
  isQueueModuleActive: (_state, getters) => {
    const queueModule = getters.queueModule
    return queueModule ? Boolean(queueModule?.pivot?.status) : false
  },
  updateClearTimeList: (state) => {
    return state.updateClearTimeList
  },
  clearTimeToEdit: (state) => {
    return state.clearTimeToEdit
  }
}

const actions = {
  addClearTime(_context, { clearTime, label, recurrence }) {
    return new Promise((resolve, reject) => {
      queueApiV1NoCache
        .post("/clear-times", {
          clear_time: helpers.convertTimeToUTC(clearTime),
          label,
          recurrence
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateClearTime(_context, { id, clearTime, label, recurrence }) {
    return new Promise((resolve, reject) => {
      queueApiV1NoCache
        .put(`/clear-times/${id}`, {
          clear_time: helpers.convertTimeToUTC(clearTime),
          label,
          recurrence
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getClearTimes() {
    return new Promise((resolve, reject) => {
      queueApiV1NoCache
        .get("/clear-times")
        .then((response) => {
          resolve(
            response?.data?.data?.map((item) => ({
              ...item,
              time: helpers.convertUTCToLocalTime(item?.clear_time)
            })) || []
          )
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteClearTime(_context, id) {
    return new Promise((resolve) => {
      queueApiV1NoCache
        .delete(`/clear-times/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          resolve(error)
        })
    })
  },
  toggleClearTime(_context, item) {
    const urlParam = item?.isSwitchAll ? "all" : item?.id
    return new Promise((resolve, reject) => {
      queueApiV1NoCache
        .put(`/clear-times/${urlParam}/toggle`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getQueueLocations(_context, queryParameters) {
    const urlParams = {}
    if (queryParameters?.search) {
      urlParams.search_query = queryParameters?.search
    }
    if (queryParameters?.perPage) {
      urlParams.per_page = queryParameters?.perPage
    }
    if (queryParameters?.currentPage) {
      urlParams.page = queryParameters?.currentPage
    }
    return new Promise((resolve, reject) => {
      queueApiV1NoCache
        .get("/locations", {
          params: urlParams
        })
        .then((response) => {
          resolve(response?.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateQueueLocation(_context, { shouldEnableAll, location }) {
    const urlParam = shouldEnableAll ? "all" : location?.id
    return new Promise((resolve, reject) => {
      queueApiV1NoCache
        .put(`/locations/${urlParam}/toggle`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

const mutations = {
  setUpdateClearTimeList(state, value) {
    state.updateClearTimeList = value
  },
  setClearTimeToEdit(state, value) {
    state.clearTimeToEdit = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
